import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './SupportPage.css';

// Support channel definitions
const channels = [
  // { id: 'chat', icon: 'fa-comments', label: 'Live Chat', action: () => {/* open chat widget */} },
  { id: 'phone', icon: 'fa-phone', label: '+1(855)444-0060', href: 'tel:+18554440060' },
  { id: 'email', icon: 'fa-envelope', label: 'Email Support', href: 'mailto:support@voiceproconnect.com' },
        { id: 'portal', icon: 'fa-ticket', label: 'Support Portal', href: '/support-portal' },
];

// SLA table
const supportTiers = [
  { id: 'standard', name: 'Standard', coverage: '24×5 Email', sla: '< 4 hrs', price: 'Included' },
  { id: 'premium', name: 'Premium', coverage: '24×7 Email & Chat', sla: '< 2 hrs', price: '$29/user/mo' },
  { id: 'enterprise', name: 'Enterprise', coverage: 'Dedicated TAM', sla: '< 1 hr', price: 'Custom' },
];

// Popular KB topics
const topics = [
  { key: 'getting-started', title: 'Getting Started', summaries: [
      'Account creation & activation',
      'Service onboarding wizard',
      'Softphone downloads',
    ], href: '/support/getting-started' },
  { key: 'account-management', title: 'Account Management', summaries: [
      'Profile & billing settings',
      'Subscription & billing cycles',
      'Usage & invoices',
    ], href: '/support/account-management' },
  { key: 'troubleshooting', title: 'Troubleshooting', summaries: [
      'Connectivity & network issues',
      'Call quality optimization',
      'Device setup & configuration',
    ], href: '/support/troubleshooting' },
  { key: 'integration-guides', title: 'Integration Guides', summaries: [
      'CRM & Helpdesk connectors',
      'API developer docs',
      'WebRTC & SDK examples',
    ], href: '/support/integration-guides' },
];

// Developer & integration resources
const resources = [
  { id: 'api', label: 'API Documentation', href: '/docs/api' },
  { id: 'guides', label: 'Integration Guides', href: '/docs/integrations' },
  { id: 'status', label: 'System Status', href: '/status' },
  // { id: 'forum', label: 'Community Forum', href: '/forum' },
];

export default function SupportPage() {
  const [openTopicKey, setOpenTopicKey] = useState(null);
  const toggleTopic = (key) => setOpenTopicKey(openTopicKey === key ? null : key);

  return (
    <div className="support-page">
      <header className="support-hero">
        <h1>Enterprise Support Center</h1>
        <p>Rapid, reliable support & services—custom SLAs, dedicated teams, and 24/7 coverage.</p>
      </header>
      <div className="support-channels">
        {channels.map(c => (
          c.href ? (
            c.id === 'portal' ? (
              <Link key={c.id} to={c.href} className="support-channel">
                <i className={`fa ${c.icon}`} aria-hidden="true"></i> {c.label}
              </Link>
            ) : (
              <a key={c.id} href={c.href} className="support-channel">
                <i className={`fa ${c.icon}`} aria-hidden="true"></i> {c.label}
              </a>
            )
          ) : (
            <button key={c.id} onClick={c.action} className="support-channel">
              <i className={`fa ${c.icon}`} aria-hidden="true"></i> {c.label}
            </button>
          )
        ))}
      </div>
      {/*<div className="support-search">*/}
      {/*  <input type="search" placeholder="Search knowledge base..." aria-label="Search support articles" />*/}
      {/*</div>*/}
      <section className="support-sla">
        <h2>Support Tiers & SLAs</h2>
        <table className="sla-table">
          <thead>
            <tr><th>Tier</th><th>Coverage</th><th>Response SLA</th><th>Price</th></tr>
          </thead>
          <tbody>
            {supportTiers.map(t => (
              <tr key={t.id}>
                <td>{t.name}</td><td>{t.coverage}</td><td>{t.sla}</td><td>{t.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      <section className="support-topics">
        <h2>Popular Topics</h2>
        {topics.map(topic => (
          <div key={topic.key}>
            <button
              className="accordion"
              aria-expanded={openTopicKey === topic.key}
              onClick={() => toggleTopic(topic.key)}
            >{topic.title}</button>
            <div className={`panel ${openTopicKey === topic.key ? 'open' : ''}`}>
              <ul>
                {topic.summaries.map((s,i) => <li key={i}>{s}</li>)}
              </ul>
              <a className="read-more" href={topic.href}>Read more</a>
            </div>
          </div>
        ))}
      </section>
      <section className="support-resources">
        <h2>Developer & Integration Resources</h2>
        <ul>
          {resources.map(r => (<li key={r.id}><a href={r.href}>{r.label}</a></li>))}
        </ul>
      </section>
      <section className="support-contact">
        <h2>Need More Help?</h2>
        <Link to="/support-portal" className="btn-primary">
          Open a Support Ticket
        </Link>
        {/*<button className="btn-secondary" onClick={() => /!* open chat widget *!/}>*/}
        {/*  Live Chat*/}
        {/*</button>*/}
      </section>
    </div>
  );
}
